import { css } from 'linaria';

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-250);
  padding-top: var(--space-350);
`;

export const headerTopBorder = css`
  border-top: var(--space-10) solid var(--control-minor);
`;
